import { ref, watch } from 'vue';
import { TrackingFilterRequest } from '@/objects/generated';

/**
 * This store is used to store the tracking settings for the current event
 * TODO: Maybe we should make this as a generic store that can be used for all settings and not just tracking
 * @param eventId
 * @param onChange
 * @returns
 */
export const useTrackingStore = (eventId: number, onChange?: (data: TrackingFilterRequest) => void) => {
    const settings = ref<TrackingFilterRequest>(TrackingFilterRequest.FromJsValues({}));
    settings.value.EventId = eventId;

    // listening for changes in the settings object
    watch(
        settings,
        () => {
            localStorage.setItem('tracking.settings', settings.value.serialize());
            if (onChange) {
                onChange(settings.value);
            }
        },
        { deep: true },
    );

    /**
     * Load the settings from local storage if they exist. We also check if the event id matches the current event id or else we ignore the settings
     */
    if (localStorage.getItem('tracking.settings') !== null) {
        try {
            const settingsValue = TrackingFilterRequest._FromServerJson(localStorage.getItem('tracking.settings') ?? {});

            if (settingsValue.EventId === eventId) {
                settings.value = settingsValue;
            }
        } catch (e) {
            console.error('Error parsing tracking settings', e);
        }
    }

    return { settings };
};
